'use strict';

angular.module('mean.inspinia').factory('myCoordinates', ['$q', '$http', 'toaster','$window', 
    function($q, $http, toaster, $window) {

        var get = function() {
            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: 'https://extreme-ip-lookup.com/json/',
                skipAuthorization : true,
                headers: {
                    "Content-Type": "application/json;charset=utf-8"
                }
            }).then(function(response) {
                if (response.status == 200) {
                    var myCoordinates = {};
                    console.log(response);

                    myCoordinates.city = response.data.city;
                    myCoordinates.ip = response.data.query;
                    //myCoordinates.zip = response.data.postal_code;
                    if($window.navigator && $window.navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(
                            function(position) {
                                myCoordinates.lat = position.coords.latitude;
                                myCoordinates.lon = position.coords.longitude;
                                deferred.resolve(myCoordinates);
                            },
                            function(error) {
                                toaster.pop('Location Error', error.message);
                                // myCoordinates.lat = response.data.lat;
                                // myCoordinates.lon = response.data.lon;
                                // deferred.resolve(myCoordinates);
                            }
                        );
                    } else {
                        toaster.pop('Location Error', 'Could not get location');
                    }
                    
                } else {
                    toaster.pop('Location Error', 'Could not get location');
                }
            });

            return deferred.promise;
        };

        return {
            get: get
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/inspinia/public/services/my-coordinates.js